import "./src/styles/global.css";
import "./src/styles/fonts.css";

export const onClientEntry = () => {
  window.onloadCallback = () => undefined;
};
